import { render } from "./EntitySelectorGabarito.vue?vue&type=template&id=4f3fd010"
import script from "./EntitySelectorGabarito.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorGabarito.vue?vue&type=script&lang=ts"
script.render = render

export default script